import React, {Component} from 'react';
import AppNavigation from './AppNavigation';
import AppFooter from './AppFooter';
import EditBenchmark from './Subcomponents/EditBenchmark';
import withRouter from './Functions/WithRouter';

class EmpEditBenchmark extends Component {
    constructor(props) {
        super(props)

        this.state = {
        }

        this.loadWorkspace = this.loadWorkspace.bind(this)
    }

    componentDidMount(){
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";

      const { emp, id } = this.props.params

      let selectedTemplate = null
      let duplicate = null
      if (this.props.location && this.props.location.state) {
        selectedTemplate = this.props.location.state.selectedTemplate;
        duplicate = this.props.location.state.duplicate
      }

      let email = localStorage.getItem('email');
      let username = localStorage.getItem('username');
      let cuFirstName = localStorage.getItem('firstName');
      let cuLastName = localStorage.getItem('lastName');
      let activeOrg = localStorage.getItem('activeOrg');
      const orgLogo = localStorage.getItem('orgLogo');

      let orgMode = true
      if (!activeOrg || activeOrg === '' || activeOrg === 'guidedcompass') {
        orgMode = false
      }

      this.setState({ emailId: email, username, cuFirstName, cuLastName, orgLogo,
        emp, activeOrg, orgMode, selectedTemplate, benchmarkId: id, duplicate
      })
    }

    loadWorkspace(org) {
      console.log('loadWorkspace called', org)
      this.setState({ org })
    }

    render() {

      return (
          <div>
            <AppNavigation fromEmployer={true} emp={this.state.emp} org={this.state.activeOrg} orgMode={this.state.orgMode} history={this.props.navigate} loadWorkspace={this.loadWorkspace} />
            <EditBenchmark source="Employer" activeOrg={this.state.activeOrg} accountCode={this.state.emp} selectedTemplate={this.state.selectedTemplate} benchmarkId={this.state.benchmarkId} history={this.props.navigate} duplicate={this.state.duplicate}/>

            {(this.state.activeOrg) && (
              <div>
                {AppFooter(this.props.navigate,this.state.activeOrg,this.state.orgLogo)}
              </div>
            )}
          </div>
      )
    }
}

export default withRouter(EmpEditBenchmark)
